import { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CameraControls } from '@react-three/drei';
import * as viewConfig from '/data/viewConfig.json';


export default function Cam({ onCameraInitialized }) {
    const cameraControlsRef = useRef();
    const location = useLocation();
    const [isInitialized, setIsInitialized] = useState(false);

    const isMobile = window.innerWidth < 768; 
    const screenType = isMobile ? 'mobile' : 'computer'; 


    useEffect(() => {
        const cameraControls = cameraControlsRef.current;
        
        if (!isInitialized) {
            cameraControls.setLookAt(
                -38, 50, 2,   // initial position
                -38, 2.5, 0,  // initial target
                false
            );
            
            setIsInitialized(true);
            setTimeout(() => {
                const currentPath = location.pathname;
                const position = viewConfig[screenType][currentPath]?.position;
                const target = viewConfig[screenType][currentPath]?.target;

                if (position && target) {
                    cameraControls.setLookAt(...position, ...target, true);
                }

                onCameraInitialized(true);
            }, 100);
        } else {
            const currentPath = location.pathname;
            const position = viewConfig[screenType][currentPath]?.position;
            const target = viewConfig[screenType][currentPath]?.target;

            if (position && target) {
                cameraControls.setLookAt(...position, ...target, true);
            }
        }
    }, [location.pathname, isMobile, isInitialized]);

    const currentPath = location.pathname;
    const currentConfig = viewConfig[screenType]?.[currentPath];

    return (
        <CameraControls
            ref={cameraControlsRef}
            minDistance={10}
            maxDistance={100}
            enabled={true}
            verticalDragToForward={true}
            dollyToCursor={false}
            infinityDolly={false}
            minZoom={20}
            maxZoom={600}
            smoothTime={isInitialized ? currentConfig.easing : 0}
            restThreshold={0.1}
            maxPolarAngle={Math.PI / 2.2}
        />
    );
}